goog.provide("shadow.js.shim.module$$mui$x_tree_view$TreeItem");
goog.provide("module$shadow_js_shim_module$$mui$x_tree_view$TreeItem");
shadow.js.shim.module$$mui$x_tree_view$TreeItem = shadow.js.nativeProvides["@mui/x-tree-view/TreeItem"] = shadow$bridge("@mui/x-tree-view/TreeItem");
module$shadow_js_shim_module$$mui$x_tree_view$TreeItem.default = shadow.js.shim.module$$mui$x_tree_view$TreeItem;
